import qs from 'qs';

export const getQueryString = queryObject => qs.stringify(queryObject, { addQueryPrefix: true });
